import React from 'react';
import { Card } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';
import styles from './Resources.module.less';
import { trackButtonClick } from '../../../../lib/fpti';
import isAbsolutePath from '../../../../util/isAbsolutePath';

function Resources({ resourceCards }) {
  const navigate = useNavigate();

  const handleClick = (key, url) => {
    trackButtonClick(key, url);
    if (isAbsolutePath(url)) {
      window.open(url, '_blank');
    } else {
      navigate(url);
    }
  };

  return (
    <div>
      <p className={`${styles.card_section_title}`}>{resourceCards.title}</p>
      {resourceCards.cards.map((card, index) => (
        <div key={index} className={`${styles.card}`}>
          <Card onClick={() => handleClick(card.key, card.url)}>
            <div>
              <div className={`${styles.card_title}`}>{card.key}</div>
              <div className={`${styles.card_description}`}>{card.badge}</div>
              {card.text && <div dangerouslySetInnerHTML={{ __html: card.text }} />}
            </div>
          </Card>
        </div>
      ))}
    </div>
  );
}

Resources.propTypes = {
  resourceCards: PropTypes.object.isRequired
};

export default Resources;
